import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { getCurrencyFormat } from "@/utils/CurrencyFormatter";
import { PropType } from "vue";
import GridBase from "@/components/ui/grid/grid-base.vue";
import { DxColumn } from "devextreme-vue/data-grid";
import { RealtedOfferItem } from "@/types/offers/RelatedOfferItem";
import { useScreenHelper } from "@/utils/system/ScreenHelper";


export default /*#__PURE__*/_defineComponent({
  __name: 'related-offers-grid',
  props: {
  /**
   * Array of RealtedOfferItem objects representing the relateOfferList to be displayed in the grid.
   * @type {RealtedOfferItem[]}
   * @required true
   */
  relateOfferList: {
    type: Array as PropType<RealtedOfferItem[]>,
    required: true,
  },
  /**
   * The country code ID for formatting currency values.
   * @type {Number}
   * @required true
   */
  countryCode: {
    type: Number,
    default: 0,
  },
  /**
   * Indicates whether data is being loaded and the grid should show a loading state.
   * @type {Boolean}
   * @required true
   */
  loading: {
    type: Boolean,
    required: true,
  },
},
  setup(__props) {



const { isMobile } = useScreenHelper();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GridBase, {
    "data-source": __props.relateOfferList,
    "id-column-name": "id",
    "column-auto-width": true,
    loading: __props.loading,
    wordWrapEnabled: true,
    showSearchPanel: false
  }, {
    columns: _withCtx(() => [
      _createVNode(_unref(DxColumn), {
        "data-type": "date",
        format: "dd/MM/yyyy HH:mm",
        "data-field": "offerDate",
        caption: "Offer Date",
        width: "120",
        "hiding-priority": 5
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "offerAmount",
        caption: "Amount",
        format: _unref(getCurrencyFormat)(__props.countryCode),
        width: "150",
        "hiding-priority": 4
      }, null, 8, ["format"]),
      _createVNode(_unref(DxColumn), {
        "data-field": "property",
        caption: "Property",
        width: "238",
        "hiding-priority": 3
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "contact",
        caption: "Contact",
        width: _unref(isMobile) ? 150 : 200,
        "hiding-priority": 5
      }, null, 8, ["width"]),
      _createVNode(_unref(DxColumn), {
        "data-field": "statusDesc",
        caption: "Status",
        width: "110",
        "hiding-priority": 5
      })
    ]),
    _: 1
  }, 8, ["data-source", "loading"]))
}
}

})